
const currentYear = new Date().getFullYear();

export const monthOptions = Array.from({ length: 12 }, (_, i) => {
  const date = new Date(0, i);
  return { value: date.toLocaleString('default', { month: 'long' }), label: date.toLocaleString('default', { month: 'long' }) };
});

export const yearOptions = Array.from({ length: 6 }, (_, i) => {
  const year = currentYear + i;
  return { value: year.toString(), label: year.toString() };
});

// 10 saaal pehle or 10 bad, current se
export const yearOptions2 = Array.from(
  { length: currentYear - 1990 + 1 }, (_, i) => {
    const year = 1990 + i;
    return { value: year.toString(), label: year.toString() };
  }
);

// 10 saaal pehle or 10 bad, current se
export const xYearOptions = Array.from({ length: 21 }, (_, i) => {
  const year = currentYear - 10 + i;
  return { value: year.toString(), label: year.toString() };
});

export const formatDate = (date) => {
  if (!date) return "N/A";
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const handleAmountComma = (amount) => { return Number((Number(amount))?.toFixed(0))?.toLocaleString() }

export const removeCommasAndConvertToNumber = (formattedNumber) => {
  if (formattedNumber == null || formattedNumber === "") return NaN;
  return Number(String(formattedNumber).replace(/,/g, ""));
};

export const AmountInWords = (num) => {
  if (!num) return "Zero Pakistani Rupees Only";

  // Ensure num is a number
  num = typeof num === "string" ? parseInt(num.replace(/,/g, ""), 10) : num;

  const a = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen",
  ];

  const b = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety",
  ];

  const helper = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + a[n % 10] : "");
    if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 !== 0 ? " " + helper(n % 100) : "");
    if (n < 1000000)
      return helper(Math.floor(n / 1000)) + " Thousand" + (n % 1000 !== 0 ? " " + helper(n % 1000) : "");
    if (n < 1000000000)
      return helper(Math.floor(n / 1000000)) + " Million" + (n % 1000000 !== 0 ? " " + helper(n % 1000000) : "");
    if (n < 1000000000000)
      return helper(Math.floor(n / 1000000000)) + " Billion" + (n % 1000000000 !== 0 ? " " + helper(n % 1000000000) : "");
    return "Number too large";
  };

  return helper(num) + " Pakistani Rupees Only";
};

export const formatCNIC = (value) => {
  const digits = value.replace(/\D/g, "").slice(0, 13);

  if (digits.length <= 5) return digits;
  if (digits.length <= 12) return `${digits.slice(0,5)}-${digits.slice(5)}`;
  return `${digits.slice(0,5)}-${digits.slice(5,12)}-${digits.slice(12)}`;
};

export const customStyleSm = {
  control: (provided, state) => ({
    ...provided,
    fontSize: "0.755rem",
    color: "#5B6670",
    backgroundColor: "#ffffff",
    borderColor: " rgb(74, 90, 122)",
    borderRadius: "4px",
    borderWidth: "1px",
    borderStyle: "solid",
    minHeight: "30px",
    height: "30px",
    fontWeight: 400,
    lineHeight: "1.3",
    boxSizing: "border-box",
    boxShadow: state.isFocused ? "0 0 0 1px #e3e3e3" : "none",
    transition: "border-color .15s ease-in-out, box-shadow .15s ease-in-out",
    "&:hover": {
      borderColor: "#dbe0e6",
    },
    display: "flex",
    alignItems: "center",
  }),

  valueContainer: (provided) => ({
    ...provided,
    height: "30px",
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    position: "relative", // ✅ for absolute input
    flexWrap: "nowrap",
  }),

  placeholder: (provided) => ({
    ...provided,
    fontSize: "0.755rem",
    color: "rgba(157, 158, 158, 0.74)",
    marginLeft: "2px",
    position: "absolute", // ✅ overlap input
    left: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
  }),

  singleValue: (provided) => ({
    ...provided,
    fontSize: "0.755rem",
    color: "#5B6670",
  }),

  input: (provided) => ({
    ...provided,
    fontSize: "0.755rem",
    color: "#5B6670",
    margin: 0,
    padding: 0,
    position: "absolute", // ✅ same line fix
    left: "8px",
    top: "50%",
    transform: "translateY(-50%)",
  }),

  indicatorsContainer: (provided) => ({
    ...provided,
    height: "30px",
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: "0 4px",
    transition: "transform 0.2s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
    color: "rgb(182, 189, 189)",
    "&:hover": {
      color: "rgb(182, 189, 189)",
    },
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),

  option: (provided, state) => ({
    ...provided,
    width: "96%",
    fontSize: "0.755rem",
    padding: "4px 8px",
    margin: "0px 5px",
  
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    opacity: state.isDisabled ? 0.5 : 1,
  
    backgroundColor: state.isDisabled
      ? "#f5f5f5"
      : state.isSelected
        ? "rgb(70, 127, 233)"
        : state.isFocused
          ? "rgb(190, 210, 230)"
          : "#fff",
  
    color: state.isDisabled
      ? "#999"
      : state.isSelected
        ? "#fff"
        : "#000",
  
    "&:hover": {
      backgroundColor: state.isDisabled
        ? "#f5f5f5"
        : state.isSelected
          ? "rgb(70, 127, 233)"
          : "rgb(190, 210, 230)",
    },
  }),

  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    borderRadius: "4px",
    border: "1px solid #dbe0e6",
  }),
};

export const customStyleSm2 = {
  control: (provided, state) => ({
    ...provided,
    fontSize: "0.755rem",
    color: "#5B6670",
    backgroundColor: "#ffffff",
    borderColor: "#dbe0e6",
    borderRadius: "4px",
    borderWidth: "1px",
    borderStyle: "solid",
    minHeight: "30px",
    height: "30px",
    fontWeight: 400,
    lineHeight: "1.3",
    boxSizing: "border-box",
    boxShadow: state.isFocused ? "0 0 0 1px #e3e3e3" : "none",
    transition: "border-color .15s ease-in-out, box-shadow .15s ease-in-out",
    "&:hover": {
      borderColor: "#dbe0e6",
    },
    display: "flex",
    alignItems: "center",
  }),

  valueContainer: (provided) => ({
    ...provided,
    height: "30px",
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    position: "relative", // ✅ for absolute input
    flexWrap: "nowrap",
  }),

  placeholder: (provided) => ({
    ...provided,
    fontSize: "0.755rem",
    color: "rgba(157, 158, 158, 0.74)",
    marginLeft: "2px",
    position: "absolute", // ✅ overlap input
    left: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
  }),

  singleValue: (provided) => ({
    ...provided,
    fontSize: "0.755rem",
    color: "#5B6670",
  }),

  input: (provided) => ({
    ...provided,
    fontSize: "0.755rem",
    color: "#5B6670",
    margin: 0,
    padding: 0,
    position: "absolute", // ✅ same line fix
    left: "8px",
    top: "50%",
    transform: "translateY(-50%)",
  }),

  indicatorsContainer: (provided) => ({
    ...provided,
    height: "30px",
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: "0 4px",
    transition: "transform 0.2s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
    color: "rgb(182, 189, 189)",
    "&:hover": {
      color: "rgb(182, 189, 189)",
    },
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),

  option: (provided, state) => ({
    ...provided,
    width: "96%",
    fontSize: "0.755rem",
    padding: "4px 8px",
    margin: "0px 5px",
  
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    opacity: state.isDisabled ? 0.5 : 1,
  
    backgroundColor: state.isDisabled
      ? "#f5f5f5"
      : state.isSelected
        ? "rgb(70, 127, 233)"
        : state.isFocused
          ? "rgb(190, 210, 230)"
          : "#fff",
  
    color: state.isDisabled
      ? "#999"
      : state.isSelected
        ? "#fff"
        : "#000",
  
    "&:hover": {
      backgroundColor: state.isDisabled
        ? "#f5f5f5"
        : state.isSelected
          ? "rgb(70, 127, 233)"
          : "rgb(190, 210, 230)",
    },
  }),

  menu: (provided) => ({
    ...provided,
    position: "relative", // 🟢 This is the key! It forces the menu into the document flow
    zIndex: 9999,
    borderRadius: "4px",
    border: "1px solid #dbe0e6",
    boxShadow: "none",      // Optional: Looks cleaner when inline
    marginTop: "2px",
    overflowX:'hidden'      // Small gap from control
  }),

  menuList: (provided) => ({
    ...provided,
    maxHeight: "110px",     // 🟢 Limits height so it doesn't push the calendar too far
    padding: 0,
  }),
};

export const debounce = (fn, delay) => {
  let timer;

  return function (...args) {
    clearTimeout(timer);

    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
